import { Action, RequestStatus, UseCaseStateGenerator } from '@lib/plugin-redux-core';
import {
  CloneFormUseCaseState,
  ExplorePageState,
  GetFormCategoriesUseCaseState,
  GetGlobalFormsUseCaseState,
  GetGroupGlobalFormByCategoryUseCaseState,
  GetTagsUseCaseState,
} from './explore.states';
import {
  CLONE_FORM_USE_CASE,
  FIND_GLOBAL_FORMS_USE_CASE,
  FindGlobalFormsUseCaseOutput,
  Form,
  FormCategory,
  GET_GLOBAL_FORM_CATEGORIES_USE_CASE,
  GET_GROUP_GLOBAL_FORM_BY_CATEGORY_USE_CASE,
  GET_TAGS_USE_CASE,
  GetGroupGlobalFormByCategoryUseCaseOutput,
} from '@module/form';

const handleGetGlobalFormCategoriesUseCase: UseCaseStateGenerator<GetFormCategoriesUseCaseState> = {
  name: GET_GLOBAL_FORM_CATEGORIES_USE_CASE,
  executing: (state: ExplorePageState): ExplorePageState => {
    return {
      ...state,
      getGlobalFormCategoriesStatus: RequestStatus.EXECUTE,
    };
  },
  success: (state: ExplorePageState, action: Action): ExplorePageState => {
    const { payload } = action;

    return {
      ...state,
      globalFormCategories: payload as FormCategory[],
      getGlobalFormCategoriesStatus: RequestStatus.SUCCESS,
    };
  },
  error: (state: {}, action: Action) => {
    const { error } = action;
    return { ...state, error: error, getGlobalFormCategoriesStatus: RequestStatus.ERROR };
  },
  reset: (state: ExplorePageState): ExplorePageState => {
    return {
      ...state,
      getGlobalFormCategoriesStatus: RequestStatus.RESET,
    };
  },
};

const handleGetTagsUseCase: UseCaseStateGenerator<GetTagsUseCaseState> = {
  name: GET_TAGS_USE_CASE,
  executing: (state: ExplorePageState): ExplorePageState => {
    return {
      ...state,
      getTagsStatus: RequestStatus.EXECUTE,
    };
  },
  success: (state: ExplorePageState, action: Action): ExplorePageState => {
    const { payload } = action;

    return {
      ...state,
      tags: payload,
      getTagsStatus: RequestStatus.SUCCESS,
    };
  },
  error: (state: {}, action: Action) => {
    const { error } = action;
    return { ...state, error: error, getTagsStatus: RequestStatus.ERROR };
  },
  reset: (state: ExplorePageState): ExplorePageState => {
    return {
      ...state,
      getTagsStatus: RequestStatus.RESET,
    };
  },
};

const handleGetGroupGlobalFormByCategoryUseCase: UseCaseStateGenerator<GetGroupGlobalFormByCategoryUseCaseState> =
  {
    name: GET_GROUP_GLOBAL_FORM_BY_CATEGORY_USE_CASE,
    executing: (state: ExplorePageState): ExplorePageState => {
      return {
        ...state,
        getGroupGlobalFormByCategoryStatus: RequestStatus.EXECUTE,
      };
    },
    success: (state: ExplorePageState, action: Action): ExplorePageState => {
      const { payload } = action;

      return {
        ...state,
        groupGlobalFormByCategory: payload as GetGroupGlobalFormByCategoryUseCaseOutput[],
        getGroupGlobalFormByCategoryStatus: RequestStatus.SUCCESS,
      };
    },
    error: (state: {}, action: Action) => {
      const { error } = action;
      return { ...state, error: error, getGroupGlobalFormByCategoryStatus: RequestStatus.ERROR };
    },
    reset: (state: ExplorePageState): ExplorePageState => {
      return {
        ...state,
        getGroupGlobalFormByCategoryStatus: RequestStatus.RESET,
      };
    },
  };

const handleGetGlobalFormsUseCase: UseCaseStateGenerator<GetGlobalFormsUseCaseState> = {
  name: FIND_GLOBAL_FORMS_USE_CASE,
  executing: (state: ExplorePageState): ExplorePageState => {
    return {
      ...state,
      getGlobalFormsStatus: RequestStatus.EXECUTE,
    };
  },
  success: (state: ExplorePageState, action: Action): ExplorePageState => {
    const payload = action.payload as FindGlobalFormsUseCaseOutput;

    return {
      ...state,
      globalForms: payload.globalForms,
      nextToken: payload?.nextToken,
      getGlobalFormsStatus: RequestStatus.SUCCESS,
    };
  },
  error: (state: {}, action: Action) => {
    const { error } = action;
    return { ...state, error: error, getGlobalFormsStatus: RequestStatus.ERROR };
  },
  reset: (state: ExplorePageState): ExplorePageState => {
    return {
      ...state,
      globalForms: [],
      nextToken: null,
      getGlobalFormsStatus: RequestStatus.RESET,
    };
  },
};

const handleCloneFormUseCase: UseCaseStateGenerator<CloneFormUseCaseState> = {
  name: CLONE_FORM_USE_CASE,
  executing: (state: ExplorePageState): ExplorePageState => {
    return {
      ...state,
      clonedFormStatus: RequestStatus.EXECUTE,
    };
  },
  success: (state: ExplorePageState, action: Action): ExplorePageState => {
    const { payload } = action;
    const clonedForm = payload as Form;

    return {
      ...state,
      clonedFormStatus: RequestStatus.SUCCESS,
      clonedForm,
    };
  },
  error: (state: {}, action: Action) => {
    const { error } = action;
    return { ...state, error: error, cloneFormStatus: RequestStatus.ERROR };
  },
  reset: (state: ExplorePageState): ExplorePageState => {
    return {
      ...state,
      clonedFormStatus: RequestStatus.RESET,
    };
  },
};

export const exploreHandlers = [
  handleGetGlobalFormCategoriesUseCase,
  handleGetTagsUseCase,
  handleGetGroupGlobalFormByCategoryUseCase,
  handleGetGlobalFormsUseCase,
  handleCloneFormUseCase,
];
